var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('pulse-loader',{staticClass:"w-100 h-100 text-center",staticStyle:{"top":"50%"},attrs:{"loading":_vm.isLoading}}),(!_vm.isLoading)?_c('router-view'):_vm._e(),_c('Dialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }